import React, { Component } from 'react';

class Work extends Component{
    render () {

        if(this.props.data){
            var projects = this.props.data.projects.map(function(projects){
                var projectImage = 'images/'+projects.image;
                return <div key={projects.title} className="columns portfolio-item">
                  <div className="item-wrap">
                  <a target="_blank" rel="noopener noreferrer" href={projects.link} title={projects.title}>
                    <img alt={projects.title} src={projectImage} />
                    <div className="overlay">
                        <div className="portfolio-item-meta">
                        <h5>{projects.title}</h5>
                            <p>{projects.description}</p>
                        </div>
                        </div>
                    <div className="link-icon"><i className="fa fa-link"></i></div>
                    </a>
                </div>
                </div>
            });
        }
        return(
            <section id="work">
                  <div className="row">
                    <div className="twelve columns collapsed">
                        <h1>{this.props.isGerman ? "BERUFSERFAHRUNG" : "WORk"}</h1>

                        <div className="row deployed">
                            <div className="three columns header-col">
                                <h2><span>{this.props.isGerman ? "Entwickelte Websites" : "Deployed Websites"}</span></h2>
                            </div>
                            <div id="work-wrapper">
                                {projects}
                            </div>
                        </div><br/>

                        {/* <div className="row deployed">
                            <div className="three columns header-col">
                                <h2><span>{this.props.isGerman ? "lokale Projekten" : "Local projects"}</span></h2>
                            </div>
                        </div> */}

                    </div>
                </div>
            </section>

        );
    }
}
export default Work;